var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHashedPatternGreen = function SvgHashedPatternGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "hashed-pattern-green",
    x: 0,
    y: 0,
    width: 8,
    height: 8,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_647)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#2FBC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0H0V4L4 0Z",
    fill: "#26A16C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8L8 0V4L4 8H0Z",
    fill: "#26A16C"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))))));
};
export default SvgHashedPatternGreen;